import logo from "./logo.svg";
import "./App.css";
import { Home } from "./pages";
import ReactGA from "react-ga";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

function usePageViews() {
  let location = useLocation();
  useEffect(() => {
    if (!window.GA_INITIALIZED) {
      ReactGA.initialize("UA-223100136-3");
      window.GA_INITIALIZED = true;
    }
    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname);
  }, [location]);
}

function App() {
  usePageViews();
  return (
    <div
      className="App"
      style={{
        background: "linear-gradient(rgb(26 2 2), rgb(4 2 27))",
        minHeight: "100vh",
      }}
    >
      <Home />
    </div>
  );
}

export default App;
